import { render, staticRenderFns } from "./TgMemberBoardDialog.vue?vue&type=template&id=125f7463"
import script from "./TgMemberBoardDialog.vue?vue&type=script&lang=js"
export * from "./TgMemberBoardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports